// framework
import { immerable, produce } from "immer";
// api
import * as Client from "../../../../api/Client";
// models
import { ISampleViewModel } from "../models/models";

export interface IRootViewModel {
    readonly sampleViewModel: ISampleViewModel;
    readonly referenceData: {
        boreholes: Client.GetCreatePublicCoreCuttingsRequestReferenceDataResponseBoreholeDto[];
        sampleTypes: Client.GetCreatePublicCoreCuttingsRequestReferenceDataResponseSampleTypeDto[];
    };

    sampleDetailsChanged(values: ISampleViewModel): IRootViewModel;
}

export class RootViewModel implements IRootViewModel {
    [immerable] = true;

    constructor(boreholes: Client.GetCreatePublicCoreCuttingsRequestReferenceDataResponseBoreholeDto[], sampleTypes: Client.GetCreatePublicCoreCuttingsRequestReferenceDataResponseSampleTypeDto[]) {
        this.sampleViewModel = {
            uniqueId: crypto.randomUUID(),
            sampleTypes: [],
        };
        this.referenceData = {
            boreholes: boreholes,
            sampleTypes: sampleTypes,
        };
    }

    public readonly sampleViewModel: ISampleViewModel;
    public readonly referenceData: {
        boreholes: Client.GetCreatePublicCoreCuttingsRequestReferenceDataResponseBoreholeDto[];
        sampleTypes: Client.GetCreatePublicCoreCuttingsRequestReferenceDataResponseSampleTypeDto[];
    };

    public sampleDetailsChanged(values: ISampleViewModel): IRootViewModel {
        return produce(this, (draft) => {
            draft.sampleViewModel.borehole = values.borehole;
            draft.sampleViewModel.intervalTop = values.intervalTop;
            draft.sampleViewModel.intervalBottom = values.intervalBottom;
            draft.sampleViewModel.sampleTypes = values.sampleTypes;
        });
    }
}
